import React from 'react';
import { PlotData } from 'plotly.js';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';


interface IProps {
    traces: Partial<PlotData>[],
    chartOrientation: string,
    chartHeight: string,
    labelTitle: string,
    valueTitle: string,
    filterState?: any[],
    selectableFilter: boolean,
    onChanged: Function;
}
interface IState {

}
export class DashTable extends React.Component<IProps, IState> {
    state = {
      selected: new Set(this.props.filterState || null),
    };
    constructor(props, context) {
        super(props, context);
    }

//Function to handle filtering when a item in the table is selected
  handleClick = (event, id) => {
      const { selected } = this.state;
      let newSelected: Set <any> = selected;

      if (!selected.has(id)) {
        newSelected.add(id);
      } else {
        newSelected.delete(id);
      }   

	  let points: Partial<Plotly.PlotDatum>[] = [{
		y: id,
		x: id,		
	  }];
	  
      this.props.onChanged({ points });
    };

  isSelected = id => this.state.selected.has(id);

  render = () => {
    const { traces, chartOrientation, chartHeight, labelTitle, valueTitle, selectableFilter } = this.props;
    let chartTraces = new Set;
    traces?.forEach(a => chartTraces.add(a.name))

    //transform the traces into one array 
    let combinedTraces = []
    let labs = [];

    //Get unique labels. 
    //If chart is vertical, the x values are the labels
    //If chart is horizontal, the y values are the labels
    if (chartOrientation == "v") {
      traces.forEach(a => {
        a.x.forEach(p => {
          if (labs.indexOf(p) === -1) {
            labs.push(p)
          }
        })
      })
    } else {
      traces.forEach(a => {
        a.y.forEach(p => {
          if (labs.indexOf(p) === -1) {
            labs.push(p)
          }
        })
      })
    }
    
    //Get Values. Push an array of values for each trace to create an array of arrays
    //Ensure that the correct value is pushed for each label by using the index of the label
    //Where available use the 'text' property from the traces as this has additional formatting like %, thousands separator etc 

    let vals = Array.from(Array(labs.length), () => new Array(chartTraces.size));

    for (i=0; i<chartTraces.size; i++) {
      if (chartOrientation == "v") {
        for (var x=0; x<labs.length; x++) {
          let textArray: string[] = (traces[i].text as string[] ? traces[i].text as string[] : traces[i].y as string[]);
          vals[x][i] = textArray[traces[i].x.indexOf(labs[x])] || "No data";
        }
      } else {
        for (var x=0; x<labs.length; x++) {
            let textArray: string[] = (traces[i].text as string[] ? traces[i].text as string[] : traces[i].x as string[]);
            vals[x][i] = textArray[traces[i].y.indexOf(labs[x])] || "No data";
        }
      }
    }

    //Combine values and labels
    for (var i=0; i < labs.length; i++)  {
        combinedTraces.push({values: vals[i], labels: labs[i], id: [i]});
    }

    //Return the table 
    //Use the traces to return the top headers
    //Use the processed trace data as above to produce the rows of the table
    return (
      <Table style={{minHeight: chartHeight}}>
        <TableHead>
          <TableRow>
            <TableCell key={labelTitle} style={{
                    backgroundColor: "white",
                    color: "black",
                    textAlign: "left",
                    fontSize: 14
                  }}>
                      {labelTitle}
            </TableCell>
            {(traces.length == 1 ? <TableCell key={valueTitle} style={{
                                                backgroundColor: "white",
                                                color: "black",
                                                textAlign: "left",
                                                fontSize: 14
                                            }}>
                                                {valueTitle}
                                    </TableCell> :
              traces.map(a => { 
              return (
                <TableCell key={labelTitle+a.name} style={{
                    backgroundColor: "white",
                    color: "black",
                    textAlign: "left",
                    fontSize: 14
                  }}>
                      {a.name}
                </TableCell>
              )
                }) 
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {combinedTraces.map(row => {
            return (
              <TableRow 
			  	key={row.id} 
				onClick={event => { this.handleClick(event, row.labels) }} 
				selected={this.isSelected(row.labels)}
				hover={selectableFilter}> 
                <TableCell key={row.id} style={{fontSize: 14,
                                            textAlign: "left"
                                        }}>
                                            {row.labels}
                </TableCell>
                {row.values?.map((dat, i) => {
                  return (
                    <TableCell key={row.labels+dat+i} style={{fontSize: 14,
                                                            textAlign: "left"
                                                        }}>
                                                            {dat.toLocaleString()}
                    </TableCell>
                  )
                }) 
                }
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
  );
}}